import { action } from 'satcheljs/lib/legacy';
import { default as viewStateStore } from 'owa-mail-folder-store/lib/store/store';

export default action('setMoveToFolderId')(function setMoveToFolderId(
    destinationFolderId: string
): void {
    viewStateStore.moveToDestinationFolderId = destinationFolderId;
});
